import script from "./Edit.vue?vue&type=script&setup=true&lang=js"
export * from "./Edit.vue?vue&type=script&setup=true&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=c703d15a&lang=scss&scoped=true"

import exportComponent from "C:\\xiangmu\\gas-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c703d15a"]])

export default __exports__